/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Booking_DescriptionInputs */

const en_meta_showcase_booking_description = /** @type {(inputs: Meta_Showcase_Booking_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a real-time hotel availability calendar with multi-room selection and instant confirmation: the direct booking flow we build for properties.`)
};

const lv_meta_showcase_booking_description = /** @type {(inputs: Meta_Showcase_Booking_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izmēģiniet reāllaika pieejamības kalendāru ar vairāku numuru izvēli un tūlītēju apstiprinājumu — tiešo rezervāciju plūsmu, ko veidojam īpašumiem.`)
};

/**
* | output |
* | --- |
* | "Try a real-time hotel availability calendar with multi-room selection and instant confirmation: the direct booking flow we build for properties." |
*
* @param {Meta_Showcase_Booking_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_booking_description = /** @type {((inputs?: Meta_Showcase_Booking_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Booking_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_booking_description(inputs)
	return en_meta_showcase_booking_description(inputs)
});